import { useState } from "react";
import "./style.css";
import { formatGBP } from "../../utils/currency";
type ContainerProps = {
  [x: string]: any;
};
const IncomeCalcTable = (props: ContainerProps) => {
  return (
    <div className="outgoing-wrapper">
      <div className="heading-label-only">
        <div className="table-heading">Gross</div>
      </div>
      <div className="heading-label-only">
        <div className="table-heading">Net</div>
      </div>

      <div className="month-annual-grid">
        <div></div>
        <div className="table-value-income table-heading">
          <div>Client</div>
          <div>Partner</div>
          <div>Joint</div>
        </div>
        <div className="table-subhead">Monthly</div>
        <div className="table-value-income">
          <div>{formatGBP(props.IncomeCalculationValues.ClientMonthlyGrossAmount)}</div>
          <div>{formatGBP(props.IncomeCalculationValues.PartnerMonthlyGrossAmount)}</div>
          <div>{formatGBP(props.IncomeCalculationValues.JointMonthlyGrossAmount)}</div>
        </div>
        <div className="table-subhead">Annual</div>
        <div className="table-value-income">
          <div>{formatGBP(props.IncomeCalculationValues.ClientAnnualGrossAmount)}</div>
          <div>{formatGBP(props.IncomeCalculationValues.PartnerAnnualGrossAmount)}</div>
          <div>{formatGBP(props.IncomeCalculationValues.JointAnnualGrossAmount)}</div>
        </div>
      </div>

      <div className="month-annual-grid">
        <div></div>
        <div className="table-value-income table-heading">
          <div>Client</div>
          <div>Partner</div>
          <div>Joint</div>
        </div>
        <div className="table-subhead"></div>
        <div className="table-value-income">
          <div>{formatGBP(props.IncomeCalculationValues.ClientMonthlyNetAmount)}</div>
          <div>{formatGBP(props.IncomeCalculationValues.PartnerMonthlyNetAmount)}</div>
          <div>{formatGBP(props.IncomeCalculationValues.JointMonthlyNetAmount)}</div>
        </div>
        <div className="table-subhead"></div>
        <div className="table-value-income">
          <div>{formatGBP(props.IncomeCalculationValues.ClientAnnualNetAmount)}</div>
          <div>{formatGBP(props.IncomeCalculationValues.PartnerAnnualNetAmount)}</div>
          <div>{formatGBP(props.IncomeCalculationValues.JointAnnualNetAmount)}</div>
        </div>
      </div>
    </div>
  );
};

export default IncomeCalcTable;
